import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyDataComponent } from './empty-data.component';
import { UtilityService } from 'bnsights-utilities-library';



@NgModule({
  declarations: [EmptyDataComponent],
  imports: [
    CommonModule
  ],
  exports: [
    EmptyDataComponent
  ],
  providers:[
    UtilityService
  ]
})
export class EmptyDataModule { }
